import * as React from "react";
import { createContext, useContext } from "react";
import { useBranchLimits } from "../../BranchLimits";
import { useStationLocation } from "../../StationLocation";
import { usePatronLocation } from "./usePatronLocation";

type LocalHoldingsBranchContextType = { branchIdentifier: string | null };
export const LocalHoldingsBranchContext =
  createContext<LocalHoldingsBranchContextType>(null);

/**
 * AKA getBranchToUseForAvailability
 */
export const LocalHoldingsBranchProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { visibleBranchIds } = useBranchLimits();
  const { stationLocation } = useStationLocation();
  const { availabilityLocation: patronAvailabilityLocation } =
    usePatronLocation();

  const branchIdentifier = React.useMemo(() => {
    if (
      stationLocation &&
      visibleBranchIds.includes(stationLocation.identifier)
    ) {
      return stationLocation.identifier;
    }

    // single branch with displayInCopies === true && hidden === false

    if (visibleBranchIds.length === 1) {
      return visibleBranchIds[0];
    }

    return patronAvailabilityLocation;
  }, [visibleBranchIds, stationLocation, patronAvailabilityLocation]);

  const contextValue: LocalHoldingsBranchContextType = {
    branchIdentifier,
  };

  return (
    <LocalHoldingsBranchContext.Provider value={contextValue}>
      {children}
    </LocalHoldingsBranchContext.Provider>
  );
};
export function useLocalHoldingsBranch() {
  const context = useContext(LocalHoldingsBranchContext);

  if (!context) {
    throw new Error(
      "useLocalHoldingsBranch must be used within a LocalHoldingsBranchProvider"
    );
  }

  return context;
}
